import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

export default class ModalController extends Controller {
  connect () {
    this.initializeModal()
    this.modal.show()
  }

  initializeModal () {
    const options = this.#getModalOptions()
    this.modal = new window.Modal(
      this.element,
      options,
      {
        id: 'modalContainer',
        override: false
      }
    )
  }

  open () {
    this.modal.show()
  }

  hide () {
    this.modal.hide()
  }

  disconnect () {
    this.#safeHideModal()
  }

  #getModalOptions () {
    return {
      backdropClasses: 'bg-gray-900/50 fixed inset-0 z-40',
      placement: 'center-center',
      closable: this.element.dataset.closable === 'true',
      onHide: this.#handleModalHide
    }
  }

  #handleModalHide = () => {
    ModalController.modalTurboFrame.src = null
    this.element.src = null
    this.element?.remove()
  }

  #safeHideModal () {
    try {
      this.modal.hide()
      this.#removeBackdrop()
    } catch (error) {
      // do nothing
    }
  }

  #removeBackdrop () {
    const backdropElement = ModalController.backdropElement
    if (backdropElement) {
      backdropElement.remove()
    }
  }

  static get modalTurboFrame () {
    return document.querySelector('turbo-frame[id=\'modal\']')
  }

  static get backdropElement () {
    return document.body.querySelector('[modal-backdrop]')
  }
}

stimulus.register('modal', ModalController)
